import {Model} from "../Model";
import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";

@usingJsonToModelConvertor
export default class CreditCard extends Model{

    @fromJsonObject({key: 'id'})
    public id!:number;

    @fromJsonObject({key: 'number'})
    public number!:string;

    @fromJsonObject({key: 'name'})
    public name!:string;

    @fromJsonObject({key: 'bank'})
    public bank!:string;

}